import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, LineController, BarController, Tooltip, Legend } from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { useChartData } from '../hooks/useInsights';
ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, LineController, BarController, Tooltip, Legend);
export default function DashboardChart() {
    const [bin, setBin] = useState('weekly');
    const { data: chartDataset } = useChartData(bin);
    const data = useMemo(() => {
        if (!chartDataset) {
            return { labels: [], datasets: [] };
        }
        const { labels, inventoryData, refillData, forecastData } = chartDataset;
        const hasForecast = forecastData.some(v => v !== null);
        return {
            labels,
            datasets: [
                {
                    type: 'line',
                    label: 'Inventory (blocks)',
                    data: inventoryData,
                    borderColor: '#1976d2',
                    backgroundColor: 'rgba(25, 118, 210, 0.2)',
                    tension: 0.2,
                },
                {
                    type: 'bar',
                    label: 'Refills (blocks)',
                    data: refillData,
                    backgroundColor: 'rgba(76, 175, 80, 0.5)',
                    borderColor: '#4caf50',
                },
                ...(hasForecast
                    ? [
                        {
                            type: 'line',
                            label: 'Forecast',
                            data: forecastData,
                            borderColor: '#9e9e9e',
                            borderDash: [6, 4],
                            pointRadius: 0,
                        },
                    ]
                    : []),
            ],
        };
    }, [chartDataset]);
    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                title: { display: true, text: bin === 'weekly' ? 'Week' : 'Month' },
            },
            y: {
                beginAtZero: true,
                title: { display: true, text: 'Blocks' },
            },
        },
        plugins: {
            legend: { position: 'top' },
            tooltip: { enabled: true },
        },
    }), [bin]);
    const handleBinChange = (e) => {
        const val = e.target.value;
        setBin(val);
    };
    return (_jsxs(Box, { sx: { mt: 2 }, children: [_jsx(Box, { display: "flex", justifyContent: "flex-end", mb: 1, children: _jsxs(FormControl, { size: "small", sx: { minWidth: 160 }, children: [_jsx(InputLabel, { id: "chart-bin-label", children: "Aggregation" }), _jsxs(Select, { labelId: "chart-bin-label", id: "chart-bin", value: bin, label: "Aggregation", onChange: handleBinChange, children: [_jsx(MenuItem, { value: "weekly", children: "Weekly" }), _jsx(MenuItem, { value: "monthly", children: "Monthly" })] })] }) }), _jsx(Box, { sx: { height: 300 }, children: _jsx(Chart, { type: "bar", data: data, options: options }) })] }));
}
